import {
    ENTITY_MODAL_INIT,
    ENTITY_MODAL_INIT_SUCCESS,
    ENTITY_MODAL_CANCEL,
    ENTITY_CRUD_CLOSE,
    ENTITY_CRUD_HIDE,
} from 'constants/ActionTypes';
import { ACTIVITIES } from 'constants/Entities';
import { init as EntityCrudInit } from './EntityCrud';
import Context from 'managers/Context';
import { getActiveCrud } from 'utils/crud';
import { buildEntityDetailExtraId } from 'utils/entityDetailTabKey';

export function init({
    entity,
    labels,
    data,
    id,
    hideDelete,
    crudTab,
    extraInfo,
    forceRefresh,
    refreshIf,
    isCreateGlobal,
    isDetailCreateGlobal,
    hasMiddleButton,
    size,
    parentCrudInfo,
    trackingSubmodule,
}) {
    return (dispatch, getState) => {
        const activeCrud = getActiveCrud(getState());
        const activityType =
            entity?.entity === ACTIVITIES.entity
                ? (extraInfo?.activityType ?? extraInfo?.ActivityType)
                : undefined;
        const extraId = buildEntityDetailExtraId({
            activityType,
            origin: extraInfo?.origin || undefined,
            parentEntityContext: extraInfo?.parentEntityContext || undefined,
        });

        dispatch({
            type: ENTITY_MODAL_INIT,
            entity: entity,
            id,
            labels,
            hideDelete,
            fromEntity: activeCrud,
            extraInfo,
            forceRefresh,
            refreshIf,
            isCreateGlobal,
            isDetailCreateGlobal,
            hasMiddleButton,
            size,
            trackingSubmodule,
        });

        return EntityCrudInit({
            entity,
            id,
            extraId,
            isBulkAction: false,
            isFromDetail: false,
            data,
            isFromWorkFlow: false,
            isModal: true,
            crudTab,
            extraInfo,
            parentCrudInfo,
        })(dispatch, getState).then(() => {
            dispatch({
                type: ENTITY_MODAL_INIT_SUCCESS,
                entity: entity,
            });
        });
    };
}

export function completeCancel() {
    return (dispatch, getState) => {
        const state = getState();
        const entityModal = state.entityModal;
        const entityDetail = state?.entityDetail;
        const currentEntityModal = entityModal?.[entityModal?.active];
        const hasCrudInDetail = entityDetail?.[entityDetail?.active]?.hasCrudInDetail;
        const activeCrud = getActiveCrud(state);
        if (hasCrudInDetail && !activeCrud.isModal) {
            dispatch({ type: ENTITY_CRUD_HIDE });
        } else {
            dispatch({ type: ENTITY_CRUD_CLOSE });
        }

        if (currentEntityModal?.fromEntity) {
            const entity = currentEntityModal?.entity?.entity || null;
            const manager = entity && Context.entityManager.getEntitiesManager(entity);
            if (manager?.afterCrudClose) manager.afterCrudClose();
            // dispatch({
            //     type: ENTITY_CRUD_PURGE_ACTIVE,
            //     fromEntity: currentEntityModal.fromEntity,
            // });
        }
    };
}

export function cancel({ deferCrudClose = false } = {}) {
    return (dispatch, getState) => {
        dispatch({
            type: ENTITY_MODAL_CANCEL,
        });

        if (!deferCrudClose) completeCancel()(dispatch, getState);
    };
}
